import { Button, BUTTON_TYPES } from '../../../../../components/Button'
import { BTN_TXT } from '../../../../../constants'
import { Popup } from '../../../../../components/Popup'
import { Form } from 'antd'
import { Forms } from 'components/Forms'
import { useEffect, useState } from 'react'

export const EditModal = ({ open, setOpen, data, community, callbackFun }) => {
  const [form] = Form.useForm()
  const [isActive, setIsActive] = useState(false)

  const onClose = () => setOpen(false)

  const callback = () => {
    onClose()
    callbackFun()
  }

  const setInitialValue = () => {
    form.setFieldsValue({
      name: data.name,
      uuid: data.uuid,
      marketplace_ar_vendor: data.marketplace_ar_vendor,
      admin_fee: data.admin_fee,
      contracting_labor: data.contracting_labor,
      marketplace_ar_health_system_split:
        data.marketplace_ar_health_system_split,
      rebate_fee: data.rebate_fee
    })
  }

  useEffect(() => {
    if (data.name && data.uuid) {
      setInitialValue()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])
  return (
    <Popup
      visible={open}
      onCancel={onClose}
      title={'Edit fees'}
      width={442}
      footer={
        <>
          <Button type={BUTTON_TYPES.DEFAULT} upperCase onClick={onClose}>
            {BTN_TXT.CANCEL}
          </Button>
          <Button
            type={BUTTON_TYPES.PRIMARY}
            upperCase
            form="edit-fees-form"
            htmlType="submit"
            disabled={!isActive}
          >
            {BTN_TXT.SAVE}
          </Button>
        </>
      }
    >
      <Forms.EditFees
        community={community}
        data={data}
        form={form}
        setIsActive={setIsActive}
        callback={callback}
      />
    </Popup>
  )
}
